import { render, staticRenderFns } from "./CompanyDataUpdateDetails.vue?vue&type=template&id=9807c46a&scoped=true&"
import script from "./CompanyDataUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateDetails.vue?vue&type=style&index=0&id=9807c46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9807c46a",
  null
  
)

export default component.exports